export const environment = {
	production: false,
	lang: 'es',
    //apiUrl: 'http://127.0.0.1:8080/ArmorCore/', //URL SERVIDOR SPOT
    // apiUrl: 'http://localhost:8010/v2/', //URL SERVIDOR DEL CLIENTE
	apiUrl: 'v2/', //URL Servidor de Producción
	apiUrlQeQ: 'localhost',
	rolAtiendeCasosId: '1',
	entidad: 2,
	pagos: false,
	credito: true,
	cuenta: true,
	factoraje: false,
	aseguradora: false,
	ahorro: false,
	pagares: false,
	traduccion: false,
	version: '2.0.0',
	aesKey: 'cKUlJ8M62ou2pxpM2XVB6E/Dn8yhUd9liQDfjfFJAy0=',
	aesIV: '0lfr5mznSlq/OkBqxZlWjA=='
};
